import parse from "../../util/html-react-parser"

export default (html, elType) => {
    if (!html) { return null }

    // ALWAYS RETURN AN ARRAY
    const elements = parse(html)
    if (elements.length) {
        const arr = elements.filter(node => node.type === elType).map(el => el.props?.children)
        return arr
    }
    else {
        const arr = [elements.props.children]
        return arr
    }
}